export const PROPERTY_TYPES = [
  { value: "arsa", label: "Arsa", color: "#D97706" },
  { value: "tarla", label: "Tarla", color: "#15803D" },
  { value: "bahce", label: "Bahçe", color: "#65A30D" },
  { value: "mesken", label: "Mesken", color: "#0EA5E9" },
  { value: "ofis", label: "Ofis", color: "#4F46E5" },
  { value: "is_yeri", label: "İş Yeri", color: "#DC2626" },
  { value: "arsa_bina", label: "Arsa + Bina", color: "#9333EA" },
  { value: "fabrika", label: "Fabrika", color: "#18181B" },
];

export const getPropertyType = (value) =>
  PROPERTY_TYPES.find((p) => p.value === value) || PROPERTY_TYPES[0];
